import isMobileJs from "ismobilejs";

const isMobile = isMobileJs(window.navigator);

export { isMobile };
